import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-confing/http/http-client.service';
@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  logourl = "project/logos";
  carouselurl = "customer/images";
  
  constructor(private http:HttpClientService) { }
getlogos(){
  return this.http.get(this.logourl);
}
getcarousel(){
  return this.http.get(this.carouselurl);
}
}
